import CONFIG from 'configLoader';
import apiService from '@udacity/ureact-api-service';

const getWoolfTokenMutation = `
  mutation UserGenerateToken($udacityId: ID!) {
    userGenerateToken(udacityId: $udacityId, skipValidation: true) {
      token
    }
  }
`;

const getWoolfResourceIdWithReviewProjectIdQuery = `
  query GetResourceId($projectId: Int) {
    resource(projectId: $projectId) {
      woolfResourceId
    }
  }
`;

const woolfAddActivityMutation = `
mutation ActivityAdd($input: ActivityAddInput!) {
  activityAdd(input: $input) {
    activity {
      id
    }
  }
}
`;

function gql(query: string, operationName: string, variables?: { [key: string]: any }) {
  return apiService.makeGqlRequest(CONFIG.woolfIntegrationApiUrl, {
    query,
    operationName,
    variables,
  });
}

export async function getWoolfToken(userId: string) {
  const data = await gql(getWoolfTokenMutation, 'UserGenerateToken', {
    udacityId: userId,
  });
  return data?.data?.userGenerateToken?.token;
}

async function getWoolfResourceId(projectId: number) {
  const data = await gql(getWoolfResourceIdWithReviewProjectIdQuery, 'GetResourceId', { projectId });
  return data?.data?.resource?.woolfResourceId;
}

export async function recordWoolfActivity(studentUdacityId: string, projectId: number, projectSubmissionId: number) {
  if (!studentUdacityId || !projectId || !projectSubmissionId) return;

  try {
    const woolfResourceId = await getWoolfResourceId(projectId);
    if (!woolfResourceId) {
      console.info(`recordWoolfActivity skipped because no Woolf resource ID found for project ${projectId}`);
      return;
    }

    if (!window.woolf) {
      console.error('recordWoolfActivity skipped because window.woolf is undefined');
      return;
    }

    const content = '';
    const activityId = await window.woolf.trackFeedback(projectId, studentUdacityId, content);

    if (activityId) {
      await gql(woolfAddActivityMutation, 'ActivityAdd', {
        input: {
          userId: studentUdacityId,
          activityId,
          projectId,
          projectSubmissionId,
          kind: 'addFeedback',
        },
      });
      console.log('Woolf activity recorded successfully', { activityId, projectId, projectSubmissionId });
    }
  } catch (error) {
    console.error('Error recording Woolf activity:', error);
  }
}
